module.exports = __webpack_public_path__ + "google-cloud.png?e1b45d35185f1e38fd2f31414653c0c3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partners/google-cloud.png
// module id = 181
// module chunks = 0